export function cookieConsent(bodyText, privacyLabel, privacyUrl, bannerLabel)
{
    // Accepted already?
    if (localStorage.getItem('cookie_consent_accepted'))
    {
        return true;
    }

    const previouslyFocused = document.activeElement;

    //
    const banner = document.createElement('div');

    //
    banner.classList.add('cookie-consent');
    banner.setAttribute('role', 'dialog');
    banner.setAttribute('aria-live', 'polite');
    banner.setAttribute('aria-label', bannerLabel ?? '');
    banner.innerHTML = `
        <div class="label">
            <i class="icon icon-cookie" aria-hidden="true"></i>
            <span>${bodyText}</span>
        </div>
        <div class="actions">
            <a href="${privacyUrl}" class="privacy-policy">${privacyLabel}</a>
            <button type="button" class="simple-filled">OK</button>
        </div>`;

    const acceptButton = banner.querySelector('button');

    //
    acceptButton.addEventListener('click', ev =>
    {
        ev.preventDefault();

        localStorage.setItem('cookie_consent_accepted', true);
        banner.remove();

        if (previouslyFocused instanceof HTMLElement)
        {
            previouslyFocused.focus();
        }
    })

    //
    document.body.appendChild(banner);
    acceptButton.focus();
}